


(function () {

   function initializeCollectionTabs() {
    const tabButtons = document.querySelectorAll("[data-tab-button]");
    const tabPanels = document.querySelectorAll("[data-tab-panel]");

    if (!tabButtons.length || !tabPanels.length) return;

    function activateTab(tabId) {
      // Update buttons
      tabButtons.forEach((button) => {
        const isActive = button.dataset.tabButton === tabId;

        button.classList.toggle("is-active", isActive);
        button.classList.toggle("active", isActive);

        button.setAttribute("aria-selected", isActive);
        button.setAttribute("tabindex", isActive ? "0" : "-1");
      });

      // Update panels
      tabPanels.forEach((panel) => {
        const isActive = panel.dataset.tabPanel === tabId;

        panel.classList.toggle("is-active", isActive);
        panel.classList.toggle("active", isActive);

        panel.hidden = !isActive;
      });
    }

    tabButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const tabId = button.dataset.tabButton;

        activateTab(tabId);

        // Skip URL update for Coming Soon
        if (button.dataset.comingSoon === "true") return;

        const collectionUrl = button.dataset.collectionUrl;

        if (collectionUrl) {
          window.history.pushState(
            { collectionTab: tabId },
            "",
            collectionUrl
          );
        }
      });
    });
  }

  document.addEventListener("DOMContentLoaded", initializeCollectionTabs);
    // function initializeCollectionTabs(section) {
    //   if (!section || section.dataset.tabsInitialized === 'true') {
    //     return;
    //   }

    //   section.dataset.tabsInitialized = 'true';

    //   const tabButtons = Array.from(
    //     section.querySelectorAll('[data-tab-button]')
    //   );

    //   const tabPanels = Array.from(
    //     section.querySelectorAll('[data-tab-panel]')
    //   );

    //   if (!tabButtons.length || !tabPanels.length) {
    //     return;
    //   }

    //   // function activateTab(blockId, moveFocus) {
    //   //   tabButtons.forEach(function (button) {
    //   //     const isActive = button.dataset.tabButton === blockId;

    //   //     button.classList.toggle('is-active', isActive);
    //   //     button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    //   //     button.setAttribute('tabindex', isActive ? '0' : '-1');

    //   //     if (isActive && moveFocus) {
    //   //       button.focus();
    //   //     }
    //   //   });

    //   //   tabPanels.forEach(function (panel) {
    //   //     const isActive = panel.dataset.tabPanel === blockId;

    //   //     panel.classList.toggle('is-active', isActive);
    //   //     panel.hidden = !isActive;
    //   //   });
    //   // }

    //   tabButtons.forEach(function (button, index) {
    //     button.addEventListener('click', function () {
    //       activateTab(button.dataset.tabButton);

    //           const collectionUrl = button.dataset.collectionUrl;

    //           if (collectionUrl) {
    //             window.history.pushState(
    //               {
    //                 collectionTab: button.dataset.tabButton
    //               },
    //               '',
    //               collectionUrl
    //             );
    //           }
    //         });

    //     button.addEventListener('keydown', function (event) {
    //       let nextIndex = null;

    //       if (event.key === 'ArrowRight') {
    //         nextIndex = index === tabButtons.length - 1 ? 0 : index + 1;
    //       }

    //       if (event.key === 'ArrowLeft') {
    //         nextIndex = index === 0 ? tabButtons.length - 1 : index - 1;
    //       }

    //       if (event.key === 'Home') {
    //         nextIndex = 0;
    //       }

    //       if (event.key === 'End') {
    //         nextIndex = tabButtons.length - 1;
    //       }

    //       if (nextIndex === null) {
    //         return;
    //       }

    //       event.preventDefault();

    //       activateTab(
    //         tabButtons[nextIndex].dataset.tabButton,
    //         true
    //       );
    //     });
    //   });

    //   section.collectionTabsActivate = activateTab;
    // }
    
    
    function initializeAllCollectionTabs(container) {
      const scope = container || document;

      scope.querySelectorAll('[data-collection-tabs]').forEach(function (section) {
        initializeCollectionTabs(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeAllCollectionTabs(document);
      });
    } else {
      initializeAllCollectionTabs(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeAllCollectionTabs(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      const blockElement = event.target;
      const section = blockElement.closest('[data-collection-tabs]');

      if (!section) {
        return;
      }

      initializeCollectionTabs(section);

      const blockId = event.detail && event.detail.blockId
        ? event.detail.blockId
        : blockElement.dataset.tabPanel;

      if (
        blockId &&
        typeof section.collectionTabsActivate === 'function'
      ) {
        section.collectionTabsActivate(blockId, false);
      }
    });

    function cleanFacetLabels() {
  document.querySelectorAll('.facet-checkbox__text').forEach(function(el) {
    el.textContent = el.textContent.replace(/\s*\([^)]*\)\s*$/, '').trim();
  });
}

function cleanFacetLabels() {
  document.querySelectorAll('.facet-checkbox__text').forEach(function(el) {
    var cleaned = el.textContent.replace(/\s*\([^)]*\)\s*$/, '').trim();
    if (el.textContent.trim() !== cleaned) {
      el.textContent = cleaned;
    }
  });
}

function cleanFacetLabels() {
  // Filter list ke checkbox labels
  document.querySelectorAll('.facet-checkbox__text').forEach(function(el) {
    var cleaned = el.textContent.replace(/\s*\([^)]*\)\s*$/, '').trim();
    if (el.textContent.trim() !== cleaned) {
      el.textContent = cleaned;
    }
  });

  // Active/selected filter pills (top wali "Size: Extra small (XS)" pill)
  document.querySelectorAll('.active-facets__button-inner').forEach(function(el) {
    // Sirf pehla text node target karo, andar ke span (icon, remove filter) ko chhedo mat
    el.childNodes.forEach(function(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        var cleaned = node.textContent.replace(/\s*\([^)]*\)\s*$/, '').trim();
        if (node.textContent.trim() !== cleaned) {
          node.textContent = cleaned + ' ';
        }
      }
    });
  });
}

cleanFacetLabels();

var facetsContainer = document.querySelector('facet-filters-form') || document.querySelector('.facets-container');

if (facetsContainer) {
  var observer = new MutationObserver(function() {
    observer.disconnect();
    cleanFacetLabels();
    observer.observe(facetsContainer, { childList: true, subtree: true });
  });

  observer.observe(facetsContainer, {
    childList: true,
    subtree: true
  });
}

// custom sort by js here 
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    const toggle = e.target.closest('.sort-by-toggle');
    if (toggle) {
      e.stopPropagation();
      const panel = document.getElementById('filter-bar-sort');
      if (!panel) return;
      const isOpen = panel.getAttribute('aria-hidden') === 'false';
      panel.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');

      return;
    }
    const panel = document.getElementById('filter-bar-sort');
    const currentToggle = document.querySelector('.sort-by-toggle');
    if (
      panel &&
      currentToggle &&
      !currentToggle.contains(e.target) &&
      !panel.contains(e.target)
    ) {
      panel.setAttribute('aria-hidden', 'true');
      currentToggle.setAttribute('aria-expanded', 'false');
    }
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches('input[name="sort_by"]')) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.target.value);
    window.location.href = url.toString();
  });

});
// document.addEventListener('DOMContentLoaded', function () {
//   const toggle = document.querySelector('.sort-by-toggle');
//   const panel = document.getElementById('filter-bar-sort');

//   if (!toggle || !panel) return;

//   toggle.addEventListener('click', function (e) {
//     e.stopPropagation();
//     const isOpen = panel.getAttribute('aria-hidden') === 'false';
//     panel.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
//     toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
//   });

//   // Outside click pe band karo
//   document.addEventListener('click', function (e) {
//     if (!toggle.contains(e.target) && !panel.contains(e.target)) {
//       panel.setAttribute('aria-hidden', 'true');
//       toggle.setAttribute('aria-expanded', 'false');
//     }
//   });

//   // Radio select hote hi sort apply karo
//   panel.querySelectorAll('input[name="sort_by"]').forEach(function (radio) {
//     radio.addEventListener('change', function () {
//       const url = new URL(window.location.href);
//       url.searchParams.set('sort_by', this.value);
//       window.location.href = url.toString();
//     });
//   });
// });



  })();

  // size guide page script
var SIZES = [
  { size:'XS', us:'0 – 2',   bust:[31,33], waist:[24,25], hips:[34,35] },
  { size:'S',  us:'4 – 6',   bust:[34,35], waist:[26,27], hips:[36,37] },
  { size:'M',  us:'8 – 10',  bust:[36,37], waist:[28,30], hips:[38,40] },
  { size:'L',  us:'12 – 14', bust:[38,40], waist:[31,33], hips:[41,43] },
  { size:'XL', us:'16 – 18', bust:[41,43], waist:[34,36], hips:[44,46] }
];
var unit = 'in';
function fmt(pair){
  if (unit === 'in') return pair[0] + ' – ' + pair[1] + '"';
  var a = Math.round(pair[0]*2.54), b = Math.round(pair[1]*2.54);
  return a + ' – ' + b + ' cm';
}
function render(){
  if(document.getElementById('size-body')){
    document.getElementById('size-body').innerHTML = SIZES.map(function(r){
      return '<tr><td>'+r.size+'</td><td>'+r.us+'</td><td>'+fmt(r.bust)+'</td><td>'+fmt(r.waist)+'</td><td>'+fmt(r.hips)+'</td></tr>';
    }).join('');
  }
}
function setUnit(u){
  unit = u;
  var i = document.getElementById('btn-in'), c = document.getElementById('btn-cm');
  i.classList.toggle('active', u==='in'); c.classList.toggle('active', u==='cm');
  i.setAttribute('aria-pressed', u==='in'); c.setAttribute('aria-pressed', u==='cm');
  render();
}
render();